import { SvgIcon } from '@material-ui/core'

export default function CalendarAddIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M7.74933 4C7.74933 3.58579 7.41354 3.25 6.99933 3.25C6.58511 3.25 6.24933 3.58579 6.24933 4V5.81643C4.75626 6.02751 3.57671 7.20845 3.37703 8.71484L3.29048 9.36779C3.2758 9.47849 3.26177 9.58926 3.24838 9.70008C3.21287 9.99405 3.44447 10.25 3.74058 10.25H20.258C20.5541 10.25 20.7857 9.99405 20.7502 9.70008C20.7368 9.58926 20.7228 9.47849 20.7081 9.36779L20.6216 8.71484C20.4219 7.20847 19.2424 6.02754 17.7493 5.81644V4C17.7493 3.58579 17.4135 3.25 16.9993 3.25C16.5851 3.25 16.2493 3.58579 16.2493 4V5.66763C13.4216 5.4158 10.5771 5.4158 7.74933 5.66763V4Z"
                fill="currentColor"
            />
            <path
                d="M20.9439 12.2256C20.9351 11.9591 20.715 11.75 20.4484 11.75H3.55019C3.28362 11.75 3.06346 11.9591 3.0547 12.2256C2.9953 14.0332 3.10511 15.8446 3.38384 17.6359C3.59485 18.9919 4.69651 20.0335 6.06225 20.1681L7.25525 20.2858C10.4103 20.5969 13.5883 20.5969 16.7433 20.2858L17.9363 20.1681C19.3021 20.0335 20.4037 18.9919 20.6148 17.6359C20.8935 15.8446 21.0033 14.0332 20.9439 12.2256Z"
                fill="currentColor"
            />
            <g transform="translate(12 12)">
                <circle cx="6.5" cy="6.5" r="5.25" fill="currentColor" stroke="#252525" strokeWidth="1.5" />
                <path d="M6.5 4V9" stroke="#252525" strokeLinecap="round" />
                <path d="M9 6.5L4 6.5" stroke="#252525" strokeLinecap="round" />
            </g>
        </SvgIcon>
    )
}
